import { getTokenExpiry } from "../../data/utils/cookie-utils";


export function validateTokenConfig({
  pollIntervalMinutes,
  userInactiveHours,
  accessTokenExpiryHours,
  refreshBeforeExpiryMinutes,
  accessToken,
}: {
  pollIntervalMinutes: number;
  userInactiveHours: number;
  accessTokenExpiryHours: number;
  refreshBeforeExpiryMinutes: number;
  accessToken?: string | null;
}): boolean {
  const pollIntervalMs = pollIntervalMinutes * 60 * 1000;
  const userInactiveTimeout = userInactiveHours * 60 * 60 * 1000;
  const accessTokenExpiryMs = accessTokenExpiryHours * 60 * 60 * 1000;
  const refreshThresholdMs = refreshBeforeExpiryMinutes * 60 * 1000;

  let isValid = true;

  if (refreshThresholdMs > accessTokenExpiryMs) {
    console.log(`[Token] ⚠ Refresh buffer > assumed token expiry.`);
    isValid = false;
  }

  if (pollIntervalMs > accessTokenExpiryMs) {
    console.log(`[Token] ⚠ Poll interval > token expiry.`);
    isValid = false;
  }

  if (userInactiveTimeout < pollIntervalMs) {
    console.log(`[Token] ⚠ Inactivity timeout < poll interval.`);
    isValid = false;
  }

  if (accessToken) {
    const expMs = getTokenExpiry(accessToken);
    if (expMs) {
      const ttlMs = expMs - Date.now();

      if (refreshThresholdMs >= ttlMs) {
        console.log(`[Token] ⚠ Refresh buffer >= actual token lifetime.`);
        isValid = false;
      }

      if (pollIntervalMs >= ttlMs) {
        console.log(`[Token] ⚠ Poll interval >= actual token lifetime.`);
        isValid = false;
      }
    }
  }

  return isValid;
}